module.exports = __webpack_public_path__ + "static/img/2.d1ff5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/zlgl/2.jpg
// module id = VYdg
// module chunks = 0